
export function getAPIBaseUrl(version = 'v1', domain = 'analytic', privilege = '') {

    let baseUrl = "";
    const subDomain = privilege === '' ? '' : `/${privilege}`

    if (process.env.REACT_APP_ENV === "DEV") {
        baseUrl = `https://api-dev.mobiuspack.io/${version}/api${subDomain}/${domain}`;
    } else if (process.env.REACT_APP_ENV === "PRD") {
        baseUrl = `https://api.mobiuspack.io/${version}/api${subDomain}/${domain}`;
    } else {
        baseUrl = `http://localhost:5000/${version}/api${subDomain}/${domain}`;
    }
    return baseUrl;
}

export function getAppBaseURL() {

  let baseUrl = ""
  
  if (process.env.REACT_APP_ENV === 'LCL') {
    baseUrl = "http://localhost:3000/"
  } 
  else if (process.env.REACT_APP_ENV === 'PRD') {
    baseUrl = "https://ship.mobiuspack.io/"
  }
  else {
    baseUrl = "https://ship-dev.mobiuspack.io/"
  }

    return baseUrl

}

export async function getParcelInfo(parcelID = "") {
  if (!parcelID) {
    return { status: 400, message: 'Missing parcel ID' };
  }

  if (process.env.REACT_APP_DEBUG === 'true') {
    console.log('getParcelInfo - ENV:', process.env.REACT_APP_ENV);
  }

  const baseUrl = getAPIBaseUrl('v1', 'core', 'public');
  const url = `${baseUrl}/parcel/${parcelID}`;

  if (process.env.REACT_APP_DEBUG === 'true') {
    console.log('getParcelInfo - URL:', url);
  }

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await response.json();
  } catch (error) {
    console.error('Error getParcelInfo:', error);
    return { status: 500, message: error.message || `Error while fetching parcel ${parcelID}` };
  }
}